


















import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import WorkLayout from '@/views/layouts/WorkLayout.vue';
import { GET_ENTERPRISE, GET_STATUS } from '@/store/models/work/enterprises';
import { Enterprise } from '@/resources/enterprise/Enterprise';
@Component({
  components: { WorkLayout }
})
export default class WorkProductShow extends Mixins<SlotMixin>(SlotMixin) {
  public enterprise ():Enterprise {
    return this.$store.getters[GET_ENTERPRISE];
  }
  public loading ():boolean {
    return this.$store.getters[GET_STATUS] !== null;
  }
}
